import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { mergeStyleSets, Stack, Image, ImageFit, Separator } from '@fluentui/react';
import { imageMap } from '../../../../data/images.esm.js';
import { Fragment as Fragment$1 } from 'react';

var styles = mergeStyleSets({
    integrationIcon: {
        width: 16,
        height: 16
    }
});
var LinkedAddIns = function(param) {
    var items = param.items, id = param.id;
    if (!items) {
        return null;
    }
    return /*#__PURE__*/ jsx(Fragment, {
        children: Object.values(items).map(function(addIn) {
            return /*#__PURE__*/ jsxs(Fragment$1, {
                children: [
                    /*#__PURE__*/ jsx(Stack, {
                        tokens: {
                            childrenGap: 8
                        },
                        horizontal: true,
                        verticalAlign: "center",
                        children: addIn.map(function(icon) {
                            var svgIcon = imageMap[icon];
                            return /*#__PURE__*/ jsx(Image, {
                                src: svgIcon,
                                "aria-label": "".concat(icon, " icon"),
                                alt: "".concat(icon, " icon"),
                                imageFit: ImageFit.cover,
                                maximizeFrame: true,
                                className: styles.integrationIcon
                            }, "integration:".concat(id, ":").concat(addIn, ":").concat(icon));
                        })
                    }),
                    /*#__PURE__*/ jsx(Stack.Item, {
                        styles: {
                            root: {
                                ':not(:first-child)': {
                                    margin: '0 4px'
                                },
                                ':last-child': {
                                    display: 'none',
                                    margin: 'unset'
                                }
                            }
                        },
                        children: /*#__PURE__*/ jsx(Separator, {
                            vertical: true
                        })
                    })
                ]
            }, "integration:separator:".concat(id, ":").concat(addIn));
        })
    });
};

export { LinkedAddIns as default };
